import { ReactNode } from 'react'
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '@/components/ui/card'

interface AuthenticationLayoutProps {
  icon: ReactNode
  title: string
  description: string | ReactNode
  children?: ReactNode
}

export function AuthenticationLayout({
  icon,
  title,
  description,
  children,
}: AuthenticationLayoutProps) {
  return (
    <section className='flex justify-center min-h-screen p-4'>
      <section className='w-full max-w-[424px] space-y-4 mt-12'>
        <header className='flex justify-center mb-12'>
          <img src='/login-logo.png' alt='ST Engineering' className='h-12' />
        </header>

        <Card className='w-full bg-white shadow-lg'>
          <CardHeader className='space-y-4 pb-4'>
            <div className='flex justify-center'>
              <div className='w-12 h-12 rounded-xl flex items-center justify-center border border-dark-300'>
                {icon}
              </div>
            </div>

            <div className='text-center space-y-1'>
              <CardTitle className='text-2xl font-bold text-dark-900'>
                {title}
              </CardTitle>
              {typeof description === 'string' ? (
                <CardDescription className='text-sm text-dark-600'>
                  {description}
                </CardDescription>
              ) : (
                <div className='text-sm text-dark-600'>{description}</div>
              )}
            </div>
          </CardHeader>

          <CardContent className='space-y-4'>{children}</CardContent>
        </Card>
      </section>
    </section>
  )
}
